import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginRouteGuard } from "./login-route.guard";

// Components
import { LoginComponent } from './auth/login/login.component';
import { MainLayoutComponent } from "./layout/main-layout.component";
import { AdminComponent } from "./admin/admin.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { UserEditComponent } from "./user/user-edit/user-edit.component";
import { DeviceListComponent } from './devices/device-list/device-list.component';
import { LocationListComponent } from './locations/location-list/location-list.component';
import { DeviceDetailComponent } from './devices/device-detail/device-detail.component';
import { DeviceEditComponent } from './devices/device-edit/device-edit.component';
import { DeviceControllerEditComponent } from './devices/device-controller-edit/device-controller-edit.component';
import { LocationEditComponent } from './locations/location-edit/location-edit.component';
import { OrganizationListComponent } from './organization/organization-list/organization-list.component';
import { OrganizationDetailComponent } from './organization/organization-detail/organization-detail.component';
import { OrganizationEditComponent } from './organization/organization-edit/organization-edit.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent, data: { pageTitle: 'ControlBright Portal' } },
  { path: '',
    component: MainLayoutComponent,
    canActivate: [LoginRouteGuard],
    children: [
      {
        path: '', pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard', pathMatch: 'full',
        component: DashboardComponent,
        data: { pageTitle: 'ControlBright Dashboard' },
      },
      {
        path: 'user_profile', pathMatch: 'full',
        component: UserEditComponent,
        data: { pageTitle: 'ControlBright Dashboard' }
      },
      {
        path: 'users/:user_id', pathMatch: 'full',
        component: UserEditComponent,
        data: { pageTitle: 'ControlBright Dashboard' }
      },
      {
        path: 'users/new', pathMatch: 'full',
        component: UserEditComponent,
        data: { pageTitle: 'ControlBright Dashboard' }
      },
      {
        path: 'locations', pathMatch: 'full',
        component: LocationListComponent,
        data: { pageTitle: 'ControlBright Dashboard' },
      },
      {
        path: 'locations/:location_id', pathMatch: 'full',
        component: LocationEditComponent,
        data: { pageTitle: 'ControlBright Dashboard' },
      },
      {
        path: 'devices', pathMatch: 'full',
        component: DeviceListComponent,
        data: { pageTitle: 'ControlBright Dashboard' },
      },
      {
        path: 'devices/create',
        component: DeviceEditComponent
      },
      {
        path: 'devices/:device_id',
        component: DeviceDetailComponent,
      },
      {
        path: 'devices/:device_id/edit',
        component: DeviceEditComponent
      },
      {
        path: 'devices/:device_id/controllers/:controller_id',
        component: DeviceControllerEditComponent
      },
      {
        path: 'organizations',
        component: OrganizationListComponent
      },
      {
        path: 'organizations/:org_id',
        component: OrganizationDetailComponent
      },
      {
        path: 'organizations/:org_id/edit',
        component: OrganizationEditComponent
      },
      {
        path: 'admin',
        component: AdminComponent
      }
	]}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
